"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.RefreshType=void 0;var r;(function(e){e.AutoRefresh="auto-refresh",e.PullToRefresh="pull-to-refresh"})(r||(exports.RefreshType=r={}));
//# sourceMappingURL=RefreshType.js.map
